// Live wallpaper + card-surface preview for branding editors.
// Renders the ACTUAL wallpaper with a mock guest card using the existing
// cardSurfaceClass treatment — preview only, never persists anything.
import { cardSurfaceClass } from './cardSurface';

export const LiveBrandingPreview = ({ wallpaperUrl, zoom = 100, styleKey = 'frosted', label, testId = 'live-branding-preview' }) => (
    <div className="relative w-full h-44 sm:h-52 rounded-xl overflow-hidden border bg-slate-950"
        data-testid={testId} data-style={styleKey}>
        {wallpaperUrl ? (
            <div className="absolute inset-0" style={{
                backgroundImage: `url("${wallpaperUrl}")`,
                backgroundSize: 'cover', backgroundPosition: 'center',
                transform: `scale(${(zoom || 100) / 100})`, transformOrigin: 'center',
            }} data-testid={`${testId}-wallpaper`} />
        ) : (
            <div className="absolute inset-0 bg-gradient-to-br from-slate-800 to-slate-950" />
        )}
        <div className="absolute inset-0 bg-black/25 pointer-events-none" />
        <div className="absolute inset-0 flex items-center justify-center p-5">
            <div className={`${cardSurfaceClass(styleKey, 'dark')} rounded-2xl w-full max-w-[250px] px-5 py-4`}
                data-testid={`${testId}-card`}>
                <div className="h-2.5 w-3/4 rounded-full bg-white/75" />
                <div className="h-2 w-1/2 rounded-full bg-white/45 mt-2" />
                <div className="h-7 w-full rounded-lg bg-emerald-500/85 mt-3.5" />
            </div>
        </div>
        {label && (
            <span className="absolute bottom-1.5 right-2 text-[10px] font-medium text-white/75 bg-black/40 rounded px-1.5 py-0.5"
                data-testid={`${testId}-label`}>{label}</span>
        )}
    </div>
);

export default LiveBrandingPreview;
